import CheckableItems from './CheckableItems';

export default CheckableItems;
